module.exports = __webpack_public_path__ + "img/list__icon.2e03f27b.svg";